import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { SessionStorageService } from '@common/services/storage/session-storage.service';

/**
 * Allow route access only for specified roles.
 *
 * Example:
 * const ROUTES: Routes = [
 *  {
 *    path: 'administrator',
 *    component: AdministratorComponent,
 *    canActivate: [ RoleGuard ],
 *    data: { expectedRoles: [ 'administrator' ] },
 *  }
 * ]
 */
@Injectable()
export class ConfirmedTermsGuard  {
    constructor(
        private router: Router,
        private storage: SessionStorageService
    ) {}

    public canActivate(route: ActivatedRouteSnapshot): boolean {
        const expectedRoles = route.data.expectedRoles;
        const account = this.storage.namespace('account').get();

        if (
            expectedRoles &&
            account &&
            account.terms_accepted === 'YES' &&
            account.confirmed_concessionaire === 'YES'
        ) {
            this.router.navigate(['/participant']).then(() => {});
            return false;
        }

        if (
            expectedRoles &&
            account &&
            account.terms_accepted === 'YES' &&
            account.confirmed_concessionaire === 'NO'
        ) {
            this.router
                .navigate(['/terms-and-conditions/concessionaire'])
                .then(() => {});
            return false;
        }

        return true;
    }
}
